module.exports = __webpack_public_path__ + "img/youji.634e4960.png";